module.exports = __webpack_public_path__ + "img/theme-index-blue.c38b733c.png";